import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Row, Col, Input, Radio, Icon, message, Upload, Button } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
// import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
// import DynamicImport from "../../components/frame/DynamicImport";
import DynamicButton from "../../components/frame/DynamicButton";
// import DynamicFilter from "../../components/frame/DynamicFilter";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import BraftEditor from 'braft-editor'
import 'braft-editor/dist/braft.css'
import uploadService from "../../services/Common/upload-service";
import {
	changeAnnouncement,
	selectAnnouncement,
	updateAnnouncement,
} from "../../actions/announcement-actions";
import AnnouncementService from "../../services/Employee/announcement-service";


class AnnouncementList extends ReduxAbstract {

	initReload = true
	moduleName = "announcement"
	childModuleName = "announcementList"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		isEdit: false
	}

	actions = {
		changeAction: this.props.changeAnnouncement,
		selectAction: this.props.selectAnnouncement,
		updateAction: this.props.updateAnnouncement,

		deleteAction: AnnouncementService.deleteAnnouncement,
		createAction: AnnouncementService.createAnnouncement,
	}

	headerColumn = [{
			title: "新增 New",
			icon: "plus-circle-o",
			access: "c_value",
			click: () => this.createData()
		}, {
			title: "批量删除 Batch Delete",
			icon: "delete",
			access: "d_value",
			click: this.publicDelete
		}
	]


	tableColumn = [{
			title: <div><div>标题</div><div>Title</div></div>,
			dataIndex: 'title',
			key: 'title',
			className: 'table-global-head-short'
		},{
			title: <div><div>类型</div><div>Type</div></div>,
			dataIndex: 'anno_type_str',
			key: 'anno_type_str',
			className: 'table-global-head-large'
		}, {
			title: <div><div>发布日期</div><div>Release Date</div></div>,
			dataIndex: 'created_time_str',
			key: 'created_time_str',
			className: 'table-global-head-large'
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={"AnnouncementList"}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			access: "u_value",
			title: "编辑 Edit",
			click: this.updateData.bind(this, record, index)
		}, {
			size: "small",
			type: "default",
			icon: "eye",
			// access: "r_value",
			title: "查看 View",
			click: this.readData.bind(this, record, index)
		}
	]

	updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
    pdfFiles: this.dataSource().data.Data[index].pdf_paths ? JSON.parse(this.dataSource().data.Data[index].pdf_paths): [],
    htmlContent: this.dataSource().data.Data[index].content,
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index,
		isEdit: true
	})

	readData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
    pdfFiles: this.dataSource().data.Data[index].pdf_paths ? JSON.parse(this.dataSource().data.Data[index].pdf_paths): [],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index,
		isEdit: false
	})

	createData = () => this.setState({
		currentData: {
			content: "",
		},
    pdfFiles: [],
    htmlContent: '',
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null,
    isEdit: true
	})

	publicSubmit = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			const submitData = {
				...this.state.currentData,
				...values,
				content:this.state.htmlContent,
        pdf_paths: JSON.stringify(this.state.pdfFiles)
			}
			const callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
			callee(submitData);
		}
	})

	handleHTMLChange = html => this.setState({
	  	htmlContent: html
	});

	editorUpload = param => {
		let formData = new FormData();
		formData.append("uploadedFile", param.file);
		uploadService.commonUpload(formData, res => {
			param.success({
				url: res.data.Message
			});
		})
	}

  checkFileType = file => {
    const typeCheck = "application/pdf" === file.type
    if (!typeCheck) {
      message.error("请上传合法的PDF文件!", 4)
    }
    const sizeCheck = file.size < 2 * 1024 * 1024
    if (!sizeCheck) {
      message.error("上传文件的大小不能超过2M!", 4)
    }
    return typeCheck && sizeCheck;
  }

  uploadPdfFile = event => {
    const formData = new FormData();
    formData.append("uploadedFile", event.file)

    this.setState({
      isUploadingPdf: true
    }, () => uploadService.uploadPdfFile(formData, result => {
      if (result.data.Success) {
        this.setState({
          isUploadingPdf: false,
          pdfFiles: [
            ...this.state.pdfFiles,
            {
              uid: event.file.uid,
              name: event.file.name,
              status: 'done',
              url: result.data.Object
            }
          ]
        });
      }else{
        this.setState({
          isUploadingPdf: false
        })
        message.error("上传文件 " + event.file.name + " 出错, " + result.data.Errors[0], 4)
      }
    }, error => {
      this.setState({isUploadingPdf: false})
      message.error("上传文件出错", 4)
    }))
  }

removePdfFile= file => {
  const fileIndex = this.state.pdfFiles.map(file => file.uid).indexOf(file.uid)
  this.setState({
    pdfFiles: [
      ...this.state.pdfFiles.slice(0, fileIndex),
      ...this.state.pdfFiles.slice(fileIndex + 1)
    ]
  })
}
setTypeFilter = event =>{
	this.setState({anno_type:event.target.value});
	this.actions.changeAction({
		anno_type:event.target.value,
	}, "reload");
} 
	render () {
		const editorProps = {
	      height: 500,
	      contentFormat: 'html',
	      initialContent: this.state.currentData.content,
	      onHTMLChange: this.handleHTMLChange,
	      media: {
	      	uploadFn: this.editorUpload
	      }
	    }

		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={"AnnouncementList"}
						access={this.props.access} />
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Radio.Group 
							onChange={this.setTypeFilter}>
							<Radio.Button value="1">制度</Radio.Button>
							<Radio.Button value="2">公告</Radio.Button>
						</Radio.Group>
					</div>

				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="制度公告"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<Form onSubmit={this.publicSubmit} className="login-form" layout="inline">
						<Row>
						{this.state.isEdit &&
							<Col span={12}>
								<div style={{marginBottom:"15px"}}>
									<Form.Item  label={"标题"} >
										{this.props.form.getFieldDecorator('title', {
											rules: [{ required: true, message: '请输入标题' }],
											initialValue: this.state.currentData.title
										})(<Input style={{width:"240px"}} disabled={!this.state.isEdit} />)}
									</Form.Item>
								</div>
							</Col>}
							{this.state.isEdit &&<Col span={12}>
								<div style={{marginBottom:"15px"}}>
									<Form.Item label="类型">
										{this.props.form.getFieldDecorator('anno_type', {
											rules: [{ required: true, message: '请选择类型' }],
											initialValue: this.state.currentData.anno_type
										})(<Radio.Group style={{width:"240px",textAlign:"left"}} disabled={!this.state.isEdit}>
										<Radio.Button value={1}>制度</Radio.Button>
										<Radio.Button value={2}>公告</Radio.Button>
									</Radio.Group>)}
									</Form.Item>
								</div>
							</Col>}
              <Col span={24}>
							{!this.state.isEdit && <div style={{marginBottom:"15px"}}>
                  <Form.Item >
                    <Upload multiple
                      fileList={this.state.pdfFiles}
                      disabled={!this.state.isEdit}
                      beforeUpload={this.checkFileType}
                      customRequest={this.uploadPdfFile}
                      showUploadList={{
                        showRemoveIcon: this.state.isEdit
                      }}
                      onRemove={this.removePdfFile}>
                      {this.state.isEdit && <div> <Button><Icon type="upload" /> Upload </Button> </div>}
                    </Upload>
                  </Form.Item>
                </div>}
								{this.state.isEdit &&
									<div style={{marginBottom:"15px"}}>
                  <Form.Item  label="文件">
                    <Upload multiple
                      fileList={this.state.pdfFiles}
                      disabled={!this.state.isEdit}
                      beforeUpload={this.checkFileType}
                      customRequest={this.uploadPdfFile}
                      showUploadList={{
                        showRemoveIcon: this.state.isEdit
                      }}
                      onRemove={this.removePdfFile}>
                      {this.state.isEdit && <div> <Button><Icon type="upload" /> Upload </Button> </div>}
                    </Upload>
                  </Form.Item>
                </div>}

              </Col>
							<Col span={24}>
								{this.state.isEdit && <div style={{marginBottom:"15px"}}>
								  <div className="demo">
                    <BraftEditor {...editorProps}/>
                  </div>
								</div>}
								{!this.state.isEdit &&
									<div style={{margin: "0px 25px"}}>
										<div dangerouslySetInnerHTML={{__html: editorProps.initialContent}}></div>
									</div>}						
							</Col>
						</Row>
					</Form>
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.actions.changeAction} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		announcement: state.announcement
	}
}

const mapDispatchToProps = {
	changeAnnouncement,
	selectAnnouncement,
	updateAnnouncement,
}

AnnouncementList = Form.create()(AnnouncementList);

AnnouncementList = connect(mapStateToProps, mapDispatchToProps)(AnnouncementList);

export default LayoutWrapper(AnnouncementList);





// WEBPACK FOOTER //
// ./src/routes/Announcement/AnnouncementList.js